import React, { useEffect, useState } from "react";

import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { integrationsSaveWorkiz, disconnectJobber } from "@/store/integrations";
import { setMeData, userMe } from "@/store/auth";

import AppPageContainer from "@/components/AppPageContainer";
import AppBox from "@/components/AppBox";
import AppInput from "@/components/AppInput";
import AppCard from "@/components/AppCard";
import AppText from "@/components/AppText";
import AppButton from "@/components/AppButton";

interface FormWorkizState {
  api_token: string;
  api_secret: string;
}

const Integrations: React.FC = () => {
  const dispatch = useAppDispatch();

  const { me } = useAppSelector((state) => state.auth);

  const [integration, setIntegration] = useState(me.integrations[0]);
  const [formWorkiz, setFormWorkiz] = useState({api_token: '', api_secret: ''});

  useEffect(() => {
    dispatch(userMe());
  }, [dispatch]);
  
  useEffect(() => {
    if (me?.integrations?.length) {
      const jobberIntegration = me.integrations.find((i: any) => i.integration_id === 3);
      
      if (jobberIntegration) {
        setIntegration(jobberIntegration);
      }
    }
  }, [me?.integrations]);

  const handleChangeWorkiz = (field: keyof FormWorkizState) => (value: string) => {
    setFormWorkiz((state) => ({
      ...state,
      [field]: value,
    }));
  }

  const handleSubmitWorkiz = () => {
    dispatch(integrationsSaveWorkiz({...formWorkiz, integration_id: integration.integration_id}))
  }

  const handleDisconnectJobber = async () => {
    const result = await dispatch(disconnectJobber(me.id));
    if (disconnectJobber.fulfilled.match(result) && result.payload) {
      dispatch(setMeData(result.payload));
    }
  }

  const hasJobberAccessToken =
  !!integration?.settings &&
  typeof integration.settings.access_token === 'string' &&
  integration.settings.access_token.trim() !== '';

  return (
    <AppPageContainer title="Integrations">
      <AppCard>
        {
          integration && integration.integration_id === 2
            ? <AppBox column gap={4} width={320}>
                <AppText variant="h5">Workiz Integration</AppText>

                <AppBox column gap={4}>
                  <AppInput
                    type="text"
                    label="API Token"
                    fullWidth
                    onChange={handleChangeWorkiz('api_token')}
                    value={formWorkiz.api_token}
                    autoFocus={true}
                    onPressEnter={handleSubmitWorkiz}
                  />
                  
                  <AppInput
                    type="text"
                    label="API Secret"
                    fullWidth
                    onChange={handleChangeWorkiz('api_secret')}
                    value={formWorkiz.api_secret}
                    autoFocus={true}
                    onPressEnter={handleSubmitWorkiz}
                  />

                  <AppButton variant="primary" onClick={handleSubmitWorkiz}>Submit</AppButton>
                </AppBox>
              </AppBox>
            : null
        }

        {integration && integration.integration_id === 3 ? (
          <AppBox column gap={4}>
            <AppText variant="h5">Jobber</AppText>

            {/* Show Connect if settings is missing or no access_token */}
            
            {!hasJobberAccessToken ? (
              <a href="/jobber/redirect" className="w-[180px]">
                <AppButton>Connect</AppButton>
              </a>
            ) : (
              <AppBox width={180} onClick={handleDisconnectJobber}>
                <AppButton>Disconnect</AppButton>
              </AppBox>
            )}
            
            {/* {(!integration.settings || !integration.settings.access_token) ? (
              <AppBox>
                <a href="/jobber/redirect" className="w-[180px]">
                  <AppButton>Connect</AppButton>
                </a>
              </AppBox>
            ) : (
              // Show Disconnect only if access_token is present
              <AppBox width={180} onClick={handleDisconnectJobber}>
                <AppButton>Disconnect</AppButton>
              </AppBox>
            )} */}
          </AppBox>
        ) : null}
      </AppCard>
    </AppPageContainer>
  );
};

export default Integrations;